export default __webpack_public_path__ + "static/media/chat2.5aac7d23.svg";